// Company member roles as the api stores them on the company's employees entry.
// Labels and rights texts live in the locales (companyContacts.roles).
export const COMPANY_ADMIN_ROLE = 225;
export const COMPANY_ROLE_VALUES = [200, 205, 210, 215, 220, 225];

export const companyRoleLabel = (language, role) =>
  language.getValue(`companyContacts.roles.${role}.label`, '');

export const companyRoleDescription = (language, role) =>
  language.getValue(`companyContacts.roles.${role}.description`, '');

export const companyRoleOptions = (language) =>
  COMPANY_ROLE_VALUES.map((value) => ({
    value: String(value),
    label: companyRoleLabel(language, value),
  }));
